import { useEffect } from 'react';
import { GeoSearchControl, GoogleProvider } from 'leaflet-geosearch';
import { useMap } from 'react-leaflet';
import 'leaflet-geosearch/dist/geosearch.css';
import './SearchControl.css';

import L from 'leaflet';

const SearchBarControl = (props) => {
  const provider = new GoogleProvider({ apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY });

  const searchControl = new GeoSearchControl({
    provider: provider,
    autoComplete: true, // optional: true|false  - default true
    autoCompleteDelay: 250, // optional: number      - default
    showMarker: false, // optional: true|false  - default true
    showPopup: false, // optional: true|false  - default false
    style: 'bar',
    marker: {
      // optional: L.Marker    - default L.Icon.Default
      icon: new L.Icon.Default(),
      draggable: false,
    },
    // eslint-disable-next-line no-unused-vars
    popupFormat: ({ query, result }) => result.label, // optional: function    - default returns result label,
    resultFormat: ({ result }) => result.label, // optional: function    - default returns result label
    maxMarkers: 1, // optional: number      - default 1
    retainZoomLevel: false, // optional: true|false  - default false
    animateZoom: true, // optional: true|false  - default true
    autoClose: true, // optional: true|false  - default false
    searchLabel: 'Enter address', // optional: string      - default 'Enter address'
    keepResult: false, // optional: true|false  - default false
    updateMap: true, // optional: true|false  - default true
    ...props,
  });

  const map = useMap();
  useEffect(() => {
    map.addControl(searchControl);
    return () => map.removeControl(searchControl);
  }, []);

  return null;
};
export default SearchBarControl;
